<ppt-actions-toolbar
  [reportData]="reportData"
  [currentView]="currentView"
  [recordsCount]="totalProperties.length"
  (navRecordNum)="navRecordNum($event)"
  [requiresSelectTempElement]="false"
></ppt-actions-toolbar>

<div class="container">
  <div class="col"></div>
  <div class="navbar">
    <ul class="navigation-list">
      <li class="navigation-item">
        <strong *ngIf="property.header?.propertyName">{{
          property.header.propertyName + ', ' + property.header.propertyAddress
        }}</strong>
      </li>
    </ul>
  </div>

  <div class="sidebar">
    <rep-development-pipeline-view-image
      [propertyImages]="property.images"
      [property]="property"
      [reportId]="reportData.reportId"
    >
    </rep-development-pipeline-view-image>
    <div class="map">
      <ng-container
        [ngTemplateOutlet]="templateProjectionMap | selectTemplateOutlet: 'miq-summary-map'"
        [ngTemplateOutletContext]="{
          content: showMap,
          summaryAddressPaths: summaryAddressPaths,
          isGroupByProperty: false,
          recordList: record,
          reportIcon: 'reportSingleIcon',
        }"
      ></ng-container>
    </div>
    <ng-template #showMap> </ng-template>
  </div>
  <div class="main-content">
    <div class="accommodation-financialterms">
      <div class="accommodation">
        <h3 class="property-title" l10nTranslate>template.accommodation</h3>
        <div>
          <mat-table [dataSource]="property.accommodations.floors || []" class="accommodation-table">
            <ng-container matColumnDef="FLOOR">
              <mat-header-cell *matHeaderCellDef l10nTranslate>template.floor</mat-header-cell>
              <mat-cell *matCellDef="let element"> {{ element.floor }} </mat-cell>
              <mat-footer-cell *matFooterCellDef class="footer" l10nTranslate> template.total </mat-footer-cell>
            </ng-container>

            <ng-container matColumnDef="SQM">
              <mat-header-cell *matHeaderCellDef l10nTranslate>template.sqm</mat-header-cell>
              <mat-cell *matCellDef="let element"> {{ element.sqm }} </mat-cell>
              <mat-footer-cell *matFooterCellDef class="footer">
                {{ property.accommodations.totalSqm }}
              </mat-footer-cell>
            </ng-container>

            <ng-container matColumnDef="SQFT">
              <mat-header-cell *matHeaderCellDef l10nTranslate>template.sqft</mat-header-cell>
              <mat-cell *matCellDef="let element"> {{ element.sqft }} </mat-cell>
              <mat-footer-cell *matFooterCellDef class="footer">
                {{ property.accommodations.totalSqft }}</mat-footer-cell
              >
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
            <mat-footer-row *matFooterRowDef="displayedColumns"></mat-footer-row>
          </mat-table>
        </div>
      </div>
      <div class="financialterms">
        <h3 class="property-title" l10nTranslate>template.financialTerms</h3>
        <div *ngIf="property.financialTerms">
          <mat-table [dataSource]="financialTermsData" class="finance-table">
            <ng-container matColumnDef="occupancyCost">
              <mat-header-cell *matHeaderCellDef l10nTranslate>template.occupancyCosts</mat-header-cell>
              <mat-cell *matCellDef="let element" l10nTranslate> {{ element.key }} </mat-cell>
              <mat-footer-cell *matFooterCellDef class="footer" l10nTranslate>template.total </mat-footer-cell>
            </ng-container>

            <ng-container matColumnDef="perSqft">
              <mat-header-cell *matHeaderCellDef class="align-right" l10nTranslate>template.perSqft</mat-header-cell>
              <mat-cell *matCellDef="let element" class="align-right"> {{ element.value }} </mat-cell>
              <mat-footer-cell *matFooterCellDef class="align-right footer">
                {{ property.financialTerms.total }}
              </mat-footer-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="financialTermColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: financialTermColumns"></mat-row>
            <mat-footer-row *matFooterRowDef="financialTermColumns"></mat-footer-row>
          </mat-table>
        </div>
      </div>
    </div>

    <h3 class="property-title" l10nTranslate>template.specificationAndAminities</h3>

    <div *ngIf="property.amenities">
      <ul class="navigation-list">
        <li *ngFor="let status of property?.amenities" class="list-item">{{ status }}</li>
      </ul>
    </div>

    <h3 class="property-title" l10nTranslate>template.statusAndCondition</h3>

    <div *ngIf="statusAndCond">
      <ul class="navigation-list">
        <li class="list-item" *ngIf="statusAndCond?.status">{{ statusAndCond.status }}</li>
        <li class="list-item" *ngIf="statusAndCond?.qualityType">{{ statusAndCond.qualityType }}</li>
        <li class="list-item" *ngIf="statusAndCond?.readyToOccupy">
          {{ ('template.readyToOccupy' | xTranslate) + ' ' + statusAndCond.readyToOccupy }}
        </li>
      </ul>
    </div>
    <h3 class="property-title" l10nTranslate>template.leasingPolicy</h3>
    <div>
      <ul class="navigation-list">
        <li class="list-item" *ngIf="property.leasingPolicy">{{ property.leasingPolicy }}</li>
      </ul>
    </div>
  </div>
</div>
